import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Combo, ComboService } from '../../../services/combo.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { MappedResponse } from '../../../share/components/ge-select-pagination/ge-select-pagination.component';
import { RateCategoryTypeEnum } from '../../models/rate-category-type.enum';
import { SpinnerService } from '../../../services/spinner.service';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import { ParseCurrencyPipe } from '../../../share/components/pipe/ParseCurrency.pipe';
import { TarifaAdheridoSddrAbiertoControllerService } from 'api-rest';
import { DownloadService } from '../../../services/download.service';



@Component({
  selector: 'app-attached-rate-open-massive-load',
  templateUrl: './attached-rate-open-massive-load.component.html',
  styleUrls: ['./attached-rate-open-massive-load.component.scss'],
})
export class AttachedRateOpenMassiveLoadComponent implements OnInit {
 selectedFile: File | null = null;
  nombreArchivo: string = '';
  file: File | null = null;
    @ViewChild('fileInput') fileInput: any;
  constructor(public dialogRef: MatDialogRef<AttachedRateOpenMassiveLoadComponent>,
        @Inject('environment') private environment: any,
        private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private tarifaAdheridoSddrAbiertoControllerService: TarifaAdheridoSddrAbiertoControllerService,
    private downloadSrv: DownloadService
  ) {}

  ngOnInit(): void {
    //this.descargar();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files && event.target.files[0];
    this.selectedFile = file || null;
  }
  descargar() {
    this.spinnerSrv.loadingShow();
     this.tarifaAdheridoSddrAbiertoControllerService.downloadImportTemplate2('response').subscribe({
       next: res => {
         console.log(res.headers);
         const templateName = this.downloadSrv.getFileName(res.headers);
         this.downloadSrv.downloadBlob(res.body!, templateName!);
         this.spinnerSrv.loadingHide();
       },
       error: error => {
         this.spinnerSrv.loadingHide();
         this.snackBarSrv.showSnackBar('Ha ocurrido un error al descargar la plantilla', 'error');
       }
     })
  }

    upload() {
    if(this.file) {
      this.spinnerSrv.loadingShow();
           let blob = this.selectedFile as Blob ;
    this.tarifaAdheridoSddrAbiertoControllerService.importTarifas2(blob).subscribe({
         next: res => {
           this.spinnerSrv.loadingHide();
           this.snackBarSrv.showSnackBar('Importación realizada correctamente', 'success');
           this.dialogRef.close(true);
         },
         error: error => {
           this.spinnerSrv.loadingHide();
           // Si hay errores de validación (puede haber más de uno), los mostramos
           if (error.error?.validationErrors && Array.isArray(error.error.validationErrors) && error.error.validationErrors.length > 0) {
              if (error.error.validationErrors.length === 1) {
                const single = error.error.validationErrors[0];
                const msg = single?.defaultMessage ? `${single.defaultMessage}\n\n` : `${JSON.stringify(single)}\n\n`;
                this.snackBarSrv.showSnackBar(msg, 'error');
             } else {
                const messages = error.error.validationErrors
                  .map((ve: any, idx: number) => ve?.defaultMessage ? `${ve.defaultMessage}\n\n` : `${JSON.stringify(ve)}\n\n`)
                  .join('');
                this.snackBarSrv.showSnackBar(messages, 'error');
             }

           } else if (error.error?.detail) {
             this.snackBarSrv.showSnackBar(error.error?.detail, 'error');
           } else {
             this.snackBarSrv.showSnackBar('Ha ocurrido un error al importar la plantilla. Por favor, contacte con el administrador de sistemas', 'error');
           }
         }
       })
    }
  }

    cerrar(): void {
    this.dialogRef.close(null);
  }
    handleFileInput(event: any) {
      const file: File = event.target.files && event.target.files[0];
      if (!file) {
        this.nombreArchivo = '';
        this.file = null;
        this.selectedFile = null;
        return;
      }
      this.file = file;
      this.selectedFile = file;
      const isXlsx = /\.xlsx$/i.test(file.name) || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (isXlsx) {
        this.nombreArchivo = file.name;
        this.snackBarSrv.showSnackBar('Se ha adjuntado el archivo Excel correctamente.', 'success');
      } else {
        this.nombreArchivo = '';
        this.selectedFile = null;
        this.snackBarSrv.showSnackBar('Por favor, seleccione un archivo Excel (.xlsx).', 'error');
      }
  }
    adjuntar() {
    this.fileInput.nativeElement.click();
  }
    closeDialog(): void {
    this.dialogRef.close();
  }

}


